import React from 'react';
import { iconSizer } from "../../../../icons2022/iconSizer";
import { XIcon16Light } from "../../../../icons2022/XIcon/XIcon16Light";
import { XIcon20Light } from "../../../../icons2022/XIcon/XIcon20Light";
import { XIcon24Regular } from "../../../../icons2022/XIcon/XIcon24Regular";
export var DeleteIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(XIcon16Light, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(XIcon20Light, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(XIcon24Regular, null);
  }
}, 'DeleteIcon');